import { IMPORT_HISTORY_STATUS, IMPORT_HISTORY_TYPE } from 'api/import_history/constants'

export const LIMIT_PER_PAGE = 20

export const BASE_STYLE = 'd-flex align-items-center'

export const STATUS_LABELS = {
  [IMPORT_HISTORY_STATUS.SUCCESS]: {
    label: '成功',
    bgColor: 'success',
    textColor: 'white',
  },
  [IMPORT_HISTORY_STATUS.FAILED]: {
    label: '失敗',
    bgColor: 'danger',
    textColor: 'white',
  },
  [IMPORT_HISTORY_STATUS.RUNNING]: { label: '処理中', bgColor: 'gray', textColor: 'white' },
  [IMPORT_HISTORY_STATUS.SKIP]: { label: '一部成功', bgColor: 'warning', textColor: 'black' },
}

export const FILTER_LABELS = {
  [IMPORT_HISTORY_TYPE.DAILY_REPORT]: {
    ALL_SELECTED: 'すべてのインポート設定',
    SOME_SELECTED: 'インポート設定で絞り込み',
  },
  [IMPORT_HISTORY_TYPE.COMMON]: {
    ALL_SELECTED: 'すべてのカテゴリー',
    SOME_SELECTED: 'カテゴリーで絞り込み',
  },
}
